import { ThickArrowSVG } from '@svgComponents/thickArrowSVG';

import styles from './NothingSelectedView.module.css';

function NothingSelectedView() {
    return (
        <div className={styles.noApplication}>
            <div className={styles.container}>
                <ThickArrowSVG />
                <h3>Select a plan from the list of details</h3>
            </div>
        </div>
    );
}

// eslint-disable-next-line import/no-default-export
export default NothingSelectedView;
